// utils
import { filter } from "lodash";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  query,
  setDoc,
  Timestamp,
  orderBy as firebaseOrderBy,
} from "firebase/firestore";
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Button,
  Backdrop,
  Modal,
  Fade,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  LinearProgress,
} from "@mui/material";
import { db, auth } from "../Firebase/firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../Firebase/firebase";
// material
// components
import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import SearchNotFound from "../components/SearchNotFound";
import {
  UserListHead,
  UserMoreMenu2,
  UserMoreMenu3,
} from "../components/_dashboard/user";
import { useParams } from "react-router-dom";
import { fCurrency } from "../utils/formatNumber";
import { Box, width } from "@mui/system";
import { DatePicker } from "react-responsive-datepicker";
import "react-responsive-datepicker/dist/index.css";
import {
  SHIPPING_ROUTES,
  PORTS,
  getAvailablePorts,
  findRoute,
} from "../constants/shippingRoutes";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  {
    id: "transactionId",
    label: "Tracking Id",
    alignRight: false,
  },
  {
    id: "route",
    label: "Ship Route",
    alignRight: false,
  },
  {
    id: "daysToDestination",
    label: "Days To Destination",
    alignRight: false,
  },
  {
    id: "status",
    label: "Status",
    alignRight: false,
  },
  { id: "" },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserDetails() {
  const [currentUser, setCurrentUser] = useState();
  const [usersList, setUsersList] = useState([]);
  const navigate = useNavigate();
  const { uid } = useParams();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
      } else {
        navigate("/login");
      }
    });
  }, [navigate]);

  useEffect(() => {
    const q = query(collection(db, `users/${uid}/orders`));
    const unSubscribe = onSnapshot(q, (snapshot) => {
      const dbUsers = [];
      snapshot.forEach((doc) => {
        dbUsers.push({
          transactionId: doc.id,
          ...doc.data(),
        });
      });
      setUsersList(dbUsers);
    });

    return unSubscribe;
  }, [uid]);

  const users = usersList.map((user) => ({
    id: uid,
    status: user.status,
    amount: user.amount,
    date: user.date,
    desc: user.desc,
    receiverAccountName: user.receiverAccountName,
    receiverAccountNumber: user.receiverAccountNumber,
    transactionOTP: user.transactionOTP,
    transactionType: user.transactionType,
    transactionId: user.transactionId,
    route: user.route,
    daysToDestination: user.daysToDestination,
  }));

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  const filteredUsers = applySortFilter(
    users,
    getComparator(order, orderBy),
    filterName
  );

  const isUserNotFound = filteredUsers.length === 0;

  // Modal
  const [openAddUserModel, setOpenAddUserModel] = useState(false);
  const [addUserAlert, setaddUserAlert] = useState("");
  const [updateButton, setUpdateButton] = useState("Add transaction");
  const [city, setCity] = useState("");
  const [details, setDetails] = useState("");
  const [heading, setHeading] = useState("");
  const [status, setStatus] = useState("");
  const [day, setDay] = useState();
  const [month, setmonth] = useState();
  const [year, setYear] = useState();
  const [selectedFromPort, setSelectedFromPort] = useState("");
  const [selectedToPort, setSelectedToPort] = useState("");
  const [daysToDestination, setDaysToDestination] = useState(20);
  const [image, setImage] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleOpenAddUserModel = () => setOpenAddUserModel(true);

  const handleCloseAddUserModel = () => {
    setOpenAddUserModel(false);
    setaddUserAlert("");
  };

  // Modal Styles
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    overflowX: "scroll",
    height: "100vh",
    display: "block",
    bgcolor: "background.paper",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 400,
    border: "none",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const handleCreate = () => {
    setUpdateButton("Loading...");
    var d = new Date();
    let hour = d.getHours().toString().padStart(2, "0");
    let min = d.getMinutes().toString().padStart(2, "0");
    let sec = d.getSeconds().toString().padStart(2, "0");

    // Ensure month and day are two digits
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");

    // Create the date string in ISO format
    const dateFormatter = `${year}-${formattedMonth}-${formattedDay}`;
    const mydate = new Date(dateFormatter);

    // Validate the route
    const route = findRoute(selectedFromPort, selectedToPort);

    if (!route) {
      setUpdateButton("Add transaction");
      setaddUserAlert("No route available between selected ports");
      return;
    }

    // If there's an image, upload it first
    if (image) {
      const storageRef = ref(
        storage,
        `orders/${uid}/${Date.now()}_${image.name}`
      );
      const uploadTask = uploadBytesResumable(storageRef, image);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(progress);
        },
        (error) => {
          console.error("Error uploading image:", error);
          setUpdateButton("Add transaction");
          setaddUserAlert("Error uploading image");
        },
        () => {
          // Get download URL and create order
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            createOrderWithImage(downloadURL, route, mydate);
          });
        }
      );
    } else {
      createOrderWithImage(null, route, mydate);
    }
  };

  const createOrderWithImage = (imageUrl, route, mydate) => {
    // Get current time for the details
    const d = new Date();
    const hour = d.getHours().toString().padStart(2, "0");
    const min = d.getMinutes().toString().padStart(2, "0");
    const sec = d.getSeconds().toString().padStart(2, "0");

    // Format date for display
    const dateFormatter = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(mydate);

    addDoc(collection(db, `users/${uid}/orders`), {
      status: status,
      route: `${selectedFromPort}-${selectedToPort}`,
      origin: route.from,
      destination: route.to,
      waypoints: route.waypoints,
      completed: false,
      createdAt: Timestamp.fromDate(mydate),
      daysToDestination: daysToDestination,
      imageUrl: imageUrl,
    })
      .then((orderDoc) => {
        addDoc(collection(db, `users/${uid}/orders/${orderDoc.id}/details`), {
          City: city,
          date: dateFormatter,
          details: details,
          heading: heading,
          time: `${hour}:${min}:${sec}`,
          updatedAt: Timestamp.fromDate(mydate),
          lat: route.from.coordinates.lat,
          lng: route.from.coordinates.lng,
          completed: false,
        })
          .then(() => {
            setUpdateButton("Add transaction");
            alert("Order created successfully");
            handleCloseAddUserModel();
          })
          .catch((err) => {
            console.log(err);
            setUpdateButton("Add transaction");
            alert("Transaction created");
          });
      })
      .catch((err) => {
        setUpdateButton("Add transaction");
        alert("an error has occurred");
        console.log(err);
      });
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied");
  };

  return (
    <div>
      <Page title="User | Dashboard">
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Order Details
            </Typography>
          </Stack>

          <div style={{ margin: "30px 0" }}>
            <Button variant="contained" onClick={handleOpenAddUserModel}>
              Add Order
            </Button>
          </div>

          <div>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={openAddUserModel}
              onClose={handleCloseAddUserModel}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={openAddUserModel}>
                <Box component="form" sx={style} noValidate autoComplete="off">
                  <div style={{ margin: "0 0 5px 0", textAlign: "center" }}>
                    <p
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "5px",
                      }}
                    >
                      Add a new transaction
                    </p>

                    <TextField
                      label="City"
                      style={{ margin: "0 0 10px 0", width: "90%" }}
                      onChange={(e) => setCity(e.target.value)}
                    />

                    <FormControl
                      style={{
                        margin: "0 0 10px 0",
                        width: "30%",
                        marginRight: "5px",
                      }}
                    >
                      <InputLabel id="demo-simple-select-label">Day</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Day"
                        onChange={(e) => setDay(e.target.value)}
                      >
                        <MenuItem value="01">01</MenuItem>
                        <MenuItem value="02">02</MenuItem>
                        <MenuItem value="03">03</MenuItem>
                        <MenuItem value="04">04</MenuItem>
                        <MenuItem value="05">05</MenuItem>
                        <MenuItem value="06">06</MenuItem>
                        <MenuItem value="07">07</MenuItem>
                        <MenuItem value="08">08</MenuItem>
                        <MenuItem value="09">09</MenuItem>
                        <MenuItem value="10">10</MenuItem>
                        <MenuItem value="11">11</MenuItem>
                        <MenuItem value="12">12</MenuItem>
                        <MenuItem value="13">13</MenuItem>
                        <MenuItem value="14">14</MenuItem>
                        <MenuItem value="15">15</MenuItem>
                        <MenuItem value="16">16</MenuItem>
                        <MenuItem value="17">17</MenuItem>
                        <MenuItem value="18">18</MenuItem>
                        <MenuItem value="19">19</MenuItem>
                        <MenuItem value="20">20</MenuItem>
                        <MenuItem value="21">21</MenuItem>
                        <MenuItem value="22">22</MenuItem>
                        <MenuItem value="23">23</MenuItem>
                        <MenuItem value="24">24</MenuItem>
                        <MenuItem value="25">25</MenuItem>
                        <MenuItem value="26">26</MenuItem>
                        <MenuItem value="27">27</MenuItem>
                        <MenuItem value="28">28</MenuItem>
                        <MenuItem value="29">29</MenuItem>
                        <MenuItem value="30">30</MenuItem>
                        <MenuItem value="31">31</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl
                      style={{
                        margin: "0 0 10px 0",
                        width: "30%",
                        marginRight: "5px",
                      }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Month
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Month"
                        onChange={(e) => setmonth(e.target.value)}
                      >
                        <MenuItem value="01">Jan</MenuItem>
                        <MenuItem value="02">Feb</MenuItem>
                        <MenuItem value="03">Mar</MenuItem>
                        <MenuItem value="04">Apr</MenuItem>
                        <MenuItem value="05">May</MenuItem>
                        <MenuItem value="06">Jun</MenuItem>
                        <MenuItem value="07">Jul</MenuItem>
                        <MenuItem value="08">Aug</MenuItem>
                        <MenuItem value="09">Sep</MenuItem>
                        <MenuItem value="10">Oct</MenuItem>
                        <MenuItem value="11">Nov</MenuItem>
                        <MenuItem value="12">Dec</MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      label="Year"
                      style={{
                        margin: "0 0 10px 0",
                        width: "30%",
                        // marginRight: "5px",
                      }}
                      onChange={(e) => setYear(e.target.value)}
                      type="number"
                    />

                    <TextField
                      label="Details"
                      style={{ margin: "0 0 10px 0", width: "90%" }}
                      onChange={(e) => setDetails(e.target.value)}
                    />

                    <TextField
                      label="Heading"
                      style={{ margin: "0 0 10px 0", width: "90%" }}
                      onChange={(e) => setHeading(e.target.value)}
                    />

                    <Autocomplete
                      fullWidth
                      options={getAvailablePorts()}
                      value={
                        getAvailablePorts().find(
                          (port) => port.value === selectedFromPort
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setSelectedFromPort(newValue ? newValue.value : "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="From Port"
                          style={{ margin: "0 0 15px 0", width: "90%" }}
                        />
                      )}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                    />

                    <Autocomplete
                      fullWidth
                      options={getAvailablePorts().filter(
                        (port) => port.value !== selectedFromPort
                      )}
                      value={
                        getAvailablePorts().find(
                          (port) => port.value === selectedToPort
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setSelectedToPort(newValue ? newValue.value : "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="To Port"
                          style={{ margin: "0 0 15px 0", width: "90%" }}
                          error={selectedToPort === selectedFromPort}
                          helperText={
                            selectedToPort === selectedFromPort
                              ? "Destination must be different from origin"
                              : ""
                          }
                        />
                      )}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                      disabled={!selectedFromPort}
                    />

                    <TextField
                      fullWidth
                      type="number"
                      label="Days to Destination"
                      value={daysToDestination}
                      onChange={(e) =>
                        setDaysToDestination(Number(e.target.value))
                      }
                      style={{ margin: "0 0 10px 0", width: "90%" }}
                      inputProps={{ min: 0.001, step: 0.001 }}
                    />

                    <FormControl
                      fullWidth
                      style={{ margin: "0 0 15px 0", width: "90%" }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Select status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Select transaction type"
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <MenuItem value="dispatched">Dispatched</MenuItem>
                        <MenuItem value="departed">Departed</MenuItem>
                        <MenuItem value="destination">Destination</MenuItem>
                        <MenuItem value="delivered">Delivered</MenuItem>
                      </Select>
                    </FormControl>

                    <div style={{ margin: "0 0 15px 0" }}>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                        id="image-upload"
                      />
                      <label htmlFor="image-upload">
                        <Button
                          variant="outlined"
                          component="span"
                          fullWidth
                          style={{ marginBottom: "10px" }}
                        >
                          Upload Image
                        </Button>
                      </label>
                      {image && (
                        <Typography variant="body2">{image.name}</Typography>
                      )}
                      {uploadProgress > 0 && uploadProgress < 100 && (
                        <LinearProgress
                          variant="determinate"
                          value={uploadProgress}
                        />
                      )}
                    </div>

                    <Button
                      variant="contained"
                      onClick={handleCreate}
                      disabled={
                        updateButton === "Add transaction" ? false : true
                      }
                      style={{ width: "100%" }}
                    >
                      {updateButton}
                    </Button>
                  </div>
                </Box>
              </Fade>
            </Modal>
          </div>

          <Card>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={users.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        const {
                          status,
                          transactionId,
                          id,
                          route,
                          daysToDestination,
                        } = row;

                        // const transactionDate = new Date(date.seconds * 1000)
                        //   .toISOString()
                        //   .substring(0, 10);

                        return (
                          <TableRow hover key={transactionId} tabIndex={-1}>
                            <TableCell align="left">
                              {transactionId}{" "}
                              <button onClick={() => handleCopy(transactionId)}>
                                Copy
                              </button>
                            </TableCell>
                            <TableCell align="left">{route}</TableCell>
                            <TableCell align="left">
                              {daysToDestination}
                            </TableCell>
                            <TableCell align="left">{status}</TableCell>
                            <TableCell align="right">
                              <UserMoreMenu2
                                transactionId={transactionId}
                                status={status}
                                uid={uid}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={users.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      </Page>
    </div>
  );
}
